import angular from 'angular';

import BlacklistDirective, { selector } from './blacklist.directive';

export default angular
    .module('application.directive.blacklist', [])
    .directive(selector, BlacklistDirective);



// WEBPACK FOOTER //
// ./src/application/directive/blacklist/index.js